/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowHikingTripTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowHikingTrip,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Hit the Trails!",
    "Adventure in Nature!",
    "Hiking Awaits!",
  ],
  title: "Hiking Trip",
  description: "Organize an exciting hiking trip.",
  longDescription:
    "Gather your friends for a thrilling hiking adventure! Choose a date, decide on a trail, and plan the gear needed for the trip!",
  emoji: "🥾",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Hiking Trip",
          emoji: "🥾",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we go on the hiking trip?",
          emoji: "📅",
          completeAction: {
            question: "Decide on a hiking trail?",
            description: "Which trail do we want to hike?",
            addModules: [
              {
                type: ModuleType.Location,
                doneType: ModuleDoneType.Voting,
                title: "What trail should we choose?",
                emoji: "🏞",
                completeAction: {
                  question: "Decide on gear needed?",
                  description: "What gear should we prepare for the hike?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What gear should we bring?",
                      emoji: "🎒",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Enjoy the Great Outdoors!",
    outroDescription:
      "Your hiking trip plans are set! Enjoy nature and adventure!",
  },
};
